<template>
  <div class="aa-wrapper">
    <div class="aa-container">
      <div class="aa-picture">
        <img src="./assets/andersonaguiar.jpg" alt="">
      </div>

      <div class="aa-about">
        <h1>
          Anderson Aguiar
        </h1>

        <div class="aa-toggle-text aa-about-text">
          <div class="is-small">
            <span class="aa-emoji">👨‍💻</span> = <span class="aa-emoji">❤️</span>
          </div>
          <p class="is-normal"><span>Software Developer</span></p>
        </div>
      </div>

      <footer>
        <div class="aa-email">
          <a href="mailto:contact@andersonaguiar.com">contact<span>@</span>andersonaguiar.com</a>
        </div>

        <div class="aa-social">
          <a href="https://linkedin.com/in/andersonaguiarrr" title="Linkedin" rel="nofollow"><img src="./assets/linkedin.svg" alt="Linkedin"></a>
          <a href="http://github.com/andersonaguiar" title="Github" rel="nofollow"><img src="./assets/github.svg" alt="Github"></a>
          <a href="http://twitter.com/andersonaguiar" title="Twitter" rel="nofollow"><img src="./assets/twitter.svg" alt="Twitter"></a>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>

import Donate from '@/components/Donate.vue'

export default {
  name: 'app',
  components: {
    Donate
  }
}
</script>

<style lang="stylus">
  *
    margin 0
    padding 0
    font-family 'Roboto', sans-serif
    box-sizing border-box
    outline none
    &::selection
      color white
      background #000

  body
    color #000
    overflow-x hidden
    min-width 320px

  a
    color #000
    text-decoration none

  .aa-wrapper
    transition background .8s
    background url(assets/bg.jpg) no-repeat top center
    // animation moveBg .5s ease-in
    background-size contain
    max-width 892px
    padding 2%
    display flex
    flex-direction column
    align-items center
    text-align center
    margin 0 auto
    position relative
    height 100vh
    min-height 580px

  .aa-container
    width 100%
    max-width 540px
    position absolute
    top 200px
    transform translateY(0)
    transition all .7s
    padding-bottom 20px
    a
      color #b2b2b2
    span
      color #000

  .aa-picture
    // width 100px
    // margin 0 auto
    opacity 0
    margin-bottom 30px
    animation show .5s ease-in
    animation-fill-mode forwards
    img
      border-radius 50%
      border 8px solid #fff
      display inline-block
      width 100%
      max-width 200px
      box-shadow 1px 10px 45px -18px #000

  .aa-about
    line-height 50px
    opacity 0
    animation show .5s ease-in .2s
    animation-fill-mode forwards
    *
      font-size 3rem
      font-weight normal
    h1
      display block
    span
      color #B2B2B2

  .aa-email
    margin 40px 0
    font-size 22px
    display block
    opacity 0
    animation show .5s ease-in .4s
    animation-fill-mode forwards

  .aa-emoji
    font-size 3rem

  footer
    width 300px
    margin 0 auto
  .aa-social
    // &:before, &:after
    //   content ''
    //   display block
    //   width 20%
    //   border solid 1px
    //   margin 5px auto
    //   color #000
    height 25px
    margin-top 50px
    display flex
    justify-content space-between
    opacity 0
    animation show .5s ease-in .8s
    animation-fill-mode forwards
    a
      display inline-block
      width 25px

  // media queries
  @media screen and (max-width: 892px)
    .aa-wrapper
      background-position-y -100%
    .aa-container
      top 50%
      transform translateY(-50%)
  @media screen and (max-width: 520px)
    html
      font-size 80%
    .aa-toggle-text
      .is-small
        display inline-block
      .is-normal
        display none
  @media screen and (min-width: 521px)
    html
      font-size 100%
    .aa-toggle-text
      .is-small
        display none
      .is-normal
        display inline-block
  @keyframes moveBg
    from
      background-position-y -100%
    to
      background-position-y 0
  @keyframes show
    from
      opacity 0
    to
      opacity 1
  @keyframes showFooter
    from
      width 0
      opacity 0
    to
      width 100%
      opacity 1
</style>
